import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { isAuthenticated } from '../../actions/authentication'
import { withNamespaces } from 'react-i18next'
import FilterRequest from './FilterRequest'
import ListRequestItems from './ListRequestItems'
import styles from '../../styles/request.module.css'
import { withCookies } from 'react-cookie';
import { RenewToken } from '../../utils/token';
import { ChatContext } from '@/ChatProvider';

const useStyles = theme => ({
    toolBar: {
        alignSelf: 'flex-end'
    }
});

class ListRequest extends Component {
    constructor(props) {
        super(props)

        this.state = {
            authenticated: false,
            expanded: false,
            data: null,
            filter: {}
        }
    }

    componentDidMount() {
        this.handleToken();
    }

    async handleToken() {
        isAuthenticated().then((result) => {
            this.setState({ authenticated: result });
            this.context.setIsAuthenticated(result);
        });
    }

    handleFilter = (filters) => {
        this.setState({
            filter: { typeRequest: filters[0], status: filters[1] }
        });
    }

    render() {
        return (
            this.state.authenticated && <div className={styles.rootRequest}>
                <FilterRequest handleFilter={this.handleFilter} />
                <ListRequestItems filter={this.state.filter} />
            </div>
        );
    }
}

ListRequest.contextType = ChatContext;
export default withNamespaces(['request'], { wait: true })(withStyles(useStyles)(withCookies(ListRequest)));